module.exports = __webpack_public_path__ + "img/can-wall.ad31b55.jpg";